
import { computed, defineComponent, ref, PropType } from 'vue';
import useStatus from './useStatus';
import useTraffic, { TRAFFIC_STATE_HINT, trafficOf } from './useTraffic';
import { StatusItem, TrafficMode } from '@/types';

const MODE_LABEL: Record<TrafficMode, string> = {
  sum: '双向总和',
  out: '仅出站',
  max: '取较大值'
};

const formatDate = (stamp: number): string => {
  const date = new Date(stamp);
  return `${date.getMonth() + 1}/${date.getDate()}`;
};

export default defineComponent({
  name: 'TableItem',
  props: {
    server: {
      type: Object as PropType<StatusItem>,
      default: () => ({})
    }
  },
  setup(props) {
    const collapsed = ref(true);
    const utils = useStatus(props);
    const { trafficEnabled } = useTraffic();
    const traffic = computed(() => trafficOf(props.server));
    const trafficDetail = computed(() => {
      const usage = traffic.value;
      const cycle = `${formatDate(usage.cycleStart)} – ${formatDate(usage.cycleEnd)}`;
      const used = usage.state === 'offline' ? '–' : utils.expandRowByteConvert.value(usage.used);
      const parts = [
        usage.limited ? `${used} / ${utils.expandRowByteConvert.value(usage.limit)}` : `${used}（不限额）`,
        `周期 ${cycle}（${usage.daysLeft} 天后重置）`,
        usage.source === 'api' ? '口径 服务商 API' : `口径 ${MODE_LABEL[usage.mode]}`
      ];
      const hint = TRAFFIC_STATE_HINT[usage.state];
      if (hint) parts.push(hint);
      return parts.join(' · ');
    });
    return {
      collapsed,
      ...utils,
      trafficEnabled,
      traffic,
      trafficDetail
    };
  }
});
